/**
 * Created by JasonChou on 16/12/13.
 */
import http from '../libs/http'

export const get = (app_id, page_id) => {
  return http.get({
    url: '/api/page',
    data: {
      params: {
        app_id,
        page_id
      }
    }
  }).then((res) => {
    return res;
  })
};

export const getPages = (app_id) => {
  return http.get({
    url: '/api/pages',
    data: {
      params: {
        app_id,
      }
    }
  }).then((res) => {
    return res;
  })
};

export const getPagesAndDirs = (app_id) => {
  return http.get({
    url: '/api/pages/pages_n_dirs_wuwei',
    data: {
      params: {
        app_id
      }
    }
  }).then((res) => {
    return res;
  })
};

export const savePage = (app_id, page_id, name, path, desc, keywords, isHomepage, urlParams, extra, initDataSource, height, width, layoutType, type, eventList, widgets, datas = [], isComponent = false) => {
  return http.put({
    url: '/api/page',
    data: {
      app_id,
      page_id,
      name,
      path,
      desc,
      keywords,
      is_home: isHomepage,
      urlParams,
      extra,
      initDataSource,
      height,
      width,
      layoutType,
      type,
      eventList,
      widgets,
      datas,
      isComponent
    }
  }).then((res) => {
    return res;
  });
};

export const deletePage = (app_id, page_id, removed_user_id) => {
  return http.delete({
    url: '/api/page',
    data: {
      params: {
        app_id,
        page_id,
        removed_user_id
      }
    }
  }).then((res) => {
    return res;
  })
};

export const getMVP = () => {
  return http.get({
    url: '/api/page/rules'
  }).then((res) => {
    return res;
  })
};

export const saveControls = (app_id, page_id, controls, widgets, lastModifyTime, lastModifyUserId, force) => {
  return http.put({
    url: '/api/page/controls',
    data: {
      app_id,
      page_id,
      controls,
      widgets,
      lastModifyTime,
      lastModifyUserId,
      force,
    }
  }).then((res) => {
    return res;
  })
};

export const remove = (app_id, page_id) => {
  return http.delete({
    url: '/api/page',
    data: {
      app_id,
      page_id,
      status: 'deleted'
    }
  }).then((res) => {
    return res;
  })
};

export const create = (function_id, category, app_id, project_id, name, type, layoutType, extra, eventList, height, width,) => {
  return http.post({
    url: '/api/page',
    data: {
      app_id,
      project_id,
      name,
      type,
      layoutType,
      extra,
      eventList,
      height,
      width,
      category,
      function_id,
    }
  });
};

export const clone = (app_id, page_id, flows) => {
  return http.post({
    url: '/api/page/clone',
    data: {
      app_id,
      page_id,
      flows
    }
  });
};

export const cloneBehind = (app_id, page_id) => {
  return http.get({
    url: '/api/page/clone',
    data: {
      params: {
        app_id,
        page_id
      }
    }
  });
};

export const cloneAfter = (app_id, page_id, flows) => {
  return http.post({
    url: '/api/page/clone',
    data: {
      page_id,
      app_id,
      flows
    }
  });
};

export const importPages = (page_ids, source_app_id, app_id, mode) => {
  return http.post({
    url: '/api/pages/importPages',
    data: {
      page_ids,
      source_app_id,
      app_id,
      mode
    }
  });
};
export const importPagesCreateFlowApi = (page_ids, source_app_id, app_id) => {
  return http.post({
    url: '/api/pages/importPagesCreateFlow',
    data: {
      page_ids,
      source_app_id,
      app_id,
    }
  });
};
export const createDir = (app_id, name) => {
  return http.post({
    url: '/api/pageDir',
    data: {
      app_id,
      name
    }
  });
};

export const deleteDir = (app_id, dir_id, removed_user_id) => {
  return http.delete({
    url: '/api/pageDir',
    data: {
      params: {
        app_id,
        dir_id,
        removed_user_id
      }
    }
  });
};


export const updateDirInfo = (app_id, dir_id, dirs, pages, name, newDirId, newPageId) => {
  const data = {
    app_id,
    dir_id
  };

  if (dirs) {
    data.dirs = dirs
  }

  if (pages) {
    data.pages = pages;
  }

  if (name)
    data.name = name;

  if (newDirId) {
    data.newDirId = newDirId;
  }

  if (newPageId) {
    data.newPageId = newPageId;
  }

  return http.put({
    url: '/api/pageDir',
    data
  });
};

export const tryGetLock = (page_id, app_id) => {
  return http.get({
    url: '/api/page/lock',
    data: {
      params: {
        page_id,
        app_id,
      }
    }
  }).then((res) => {
    return res;
  })
};

export const releaseLock = (page_id, app_id) => {
  return http.delete({
    url: '/api/page/lock',
    data: {
      params: {
        page_id,
        app_id,
      }
    }
  }).then((res) => {
    return res;
  })
};

export const getPageManagementList = (page_id, app_id, version_type) => {
  return http.get({
    url: '/api/page/page_version_managements',
    data: {
      params: {
        page_id,
        app_id,
        version_type,
      }
    }
  }).then((res) => {
    return res;
  })
};

export const pageManagementAccessFiled = (params) => {
  return http.post({
    url: '/api/page/page_version_management',
    data: {
      params
    }
  });
};

export const deletePageManagement = (app_id, _id) => {
  return http.delete({
    url: '/api/page/page_version_management',
    data: {
      params: {
        app_id,
        _id
      }
    }
  });
};

export const getPageControls = (app_id, page_id) => {
  return http.get({
    url: '/api/page/controls',
    data: {
      params: {
        app_id,
        page_id
      }
    }
  }).then((res) => {
    return res;
  })
};

export const getPageFlows = (app_id, page_id) => {
  return http.get({
    url: 'api/flows',
    data: {
      params: { app_id, page_id }
    }
  }).then((res) => {
    return res.body ? res.body.data : [];
  })
}

export const snifferPage = (page_id, url) => {
  return http.get({
    url: '/api/page/sniffer',
    data: {
      params: {
        page_id,
        url,
      }
    }
  })
};

export const getPagesInfo = (appId) => {
  return http.get({
    url: '/api/page/pages_info',
    data: {
      params: {
        appId,
      }
    }
  }).then((res) => {
    return res;
  })
};
export const getFlowsByType = (app_id, type) => {
  return http.get({
    url: '/api/flow/flows',
    data: {
      params: {
        app_id,
        type
      }
    }
  }).then((res) => {
    return res;
  })
};

export const generateFormDetail = (app_id, page_id) => {
  return http.put({
    url: '/api/rdbc/generateFormDetail',
    data: {
      app_id,
      page_id
    }
  }).then((res) => {
    return res;
  })
};



// WEBPACK FOOTER //
// ./src/apis/page_apis.js